import { useQuery } from "react-query";
import { logout } from "../auth-api-client";
import { queryClient } from "../query-client";
import { enrollmentApiRequest } from "./client";
var AssessmentSubtype = /* @__PURE__ */ ((AssessmentSubtype2) => {
  AssessmentSubtype2["LESSON_PRETEST"] = "Lesson Pretest";
  AssessmentSubtype2["QUIZ"] = "Quiz";
  AssessmentSubtype2["PRACTICE_TEST"] = "Practice Test";
  AssessmentSubtype2["PRACTICE_EXAM"] = "Practice Exam";
  AssessmentSubtype2["TEST"] = "Test";
  AssessmentSubtype2["EXAM"] = "Exam";
  return AssessmentSubtype2;
})(AssessmentSubtype || {});
var ActivitySubtype = /* @__PURE__ */ ((ActivitySubtype2) => {
  ActivitySubtype2["REVISING"] = "Essay: Revising";
  ActivitySubtype2["DRAFTING"] = "Essay: Drafting";
  ActivitySubtype2["PREWRITING"] = "Essay: Prewriting";
  return ActivitySubtype2;
})(ActivitySubtype || {});
const fetchEnrollmentCourseMap = (enrollmentId) => {
  return enrollmentApiRequest({
    url: `/enrollment/${enrollmentId}/map/student`,
    method: "GET"
  });
};
const fetchEnrollmentCourseMapFlat = (enrollmentId) => {
  return enrollmentApiRequest({
    url: `/enrollment/${enrollmentId}/map/flat`,
    method: "GET"
  });
};
function useEnrollmentCourseMapQuery(enrollmentId, enabled = true) {
  return useQuery(
    ["enrollmentCourseMap", enrollmentId],
    () => fetchEnrollmentCourseMap(enrollmentId),
    {
      enabled,
      useErrorBoundary: true,
      onSuccess(course) {
        queryClient.setQueryData(["courseTitle"], course.courseTitle);
        queryClient.setQueryData(["sectionTitle"], course.sectionTitle);
      },
      onError(error) {
        if (error.status === 403)
          logout();
        else {
          throw error;
        }
      }
    }
  );
}
function useEnrollmentCourseMapFlatQuery(enrollmentId) {
  return useQuery(
    ["enrollmentCourseMapFlat", enrollmentId],
    () => fetchEnrollmentCourseMapFlat(enrollmentId),
    { useErrorBoundary: true }
  );
}
function useSectionTitleQuery() {
  return useQuery(
    ["sectionTitle"],
    () => queryClient.getQueryData(["sectionTitle"]),
    { staleTime: Infinity, cacheTime: Infinity }
  );
}
export {
  ActivitySubtype,
  AssessmentSubtype,
  useEnrollmentCourseMapFlatQuery,
  useEnrollmentCourseMapQuery,
  useSectionTitleQuery
};
